import type { AcceptInvitationRequest, LoginRequest, SessionUser } from '@robu/shared';
import { createContext } from 'react';

export type AuthStatus = 'loading' | 'authenticated' | 'anonymous';

export interface AuthContextValue {
  status: AuthStatus;
  user: SessionUser | null;
  /** True for ADMINISTRATOR and SUPER_ADMINISTRATOR. */
  isAdmin: boolean;
  isSuperAdmin: boolean;
  /** TZ §4 — a blocked player keeps read access but cannot bet. */
  isBlocked: boolean;
  login: (credentials: LoginRequest) => Promise<SessionUser>;
  acceptInvitation: (request: AcceptInvitationRequest) => Promise<SessionUser>;
  logout: () => Promise<void>;
  reloadUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
